






































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';
import CloseIcon from '@/components/icons/Close.vue';

import { IWidgetSettingsFormData } from '@/models/Widget/settings';
import { WidgetThemesDictionary } from '@/models/Widget/themes';

@Component({
  components: {
    Typography,
    CloseIcon
  }
})
export default class WidgetWelcomeMessage extends Vue {
  @Prop() widgetConfigProps!: IWidgetSettingsFormData;

  get welcomePlacementStyle() {
    const position = this.widgetConfigProps.placement.positioning;

    if (position === 'bottomLeft') {
      return {
        left: '9px'
      };
    }

    return {
      right: '9px'
    };
  }

  get themeSettings() {
    return WidgetThemesDictionary[this.widgetConfigProps.widgetStyle.color];
  }

  get themeBackgroundStyle() {
    return {
      backgroundImage: this.themeSettings.slightGradient
    };
  }
}
